/* eslint-disable max-depth */
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import Rothko from "web/script/modules/rothko";
import { connect } from "react-redux";
import { closeFeedSwitchTabOverlay } from "web/redux/ducks/feed-switch-tab-overlay";
import analytics from "web/script/analytics/analytics";
import Button from "web/react/components/button/button";
import store from "web/redux/store";
import storage from "web/script/utils/storage";
import withReduxProvider from "web/react/redux-provider";
// eslint-disable-next-line css-modules/no-unused-class
import defaultStyles from "./feed-switch-tab-overlay.css";
// eslint-disable-next-line css-modules/no-unused-class

function mapStateToProps(state) {
    const { open, productId } = state.feedSwitchTabOverlayReducer;
    return {
        overlayOpen: open,
        productId: productId,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        closeFeedSwitchTabOverlay: () => dispatch(closeFeedSwitchTabOverlay()),
    };
}

export function FeedSwitchTabOverlay({ overlayOpen }) {
    const styles = defaultStyles;
    const [product, setProduct] = useState({ data: {} });

    // Visibility Change handling
    let hidden;
    let visibilityChange;
    if (typeof document.hidden !== "undefined") {
        hidden = "hidden";
        visibilityChange = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
    }

    function handleVisibilityChange() {
        if (!document[hidden]) {
            analytics.event("feeds_tab_overlay", "view_form", "back_overlay");
            document.removeEventListener(visibilityChange, handleVisibilityChange);
        }
    }
    const appElement = useRef(null);
    useEffect(() => {
        Modal.setAppElement(appElement.current);

        const options = {
            id: storage.get("newTabOverlayProductId"),
        };

        Rothko.fetch("modules/product_card", options)
            .then((res) => setProduct(res[0]))
            .catch(() => {});
        return () => {
            document.removeEventListener(visibilityChange, handleVisibilityChange);
        };
    });

    function triggerAfterOpen() {
        analytics.event("feeds_tab_overlay", "open_switch_tab_overlay", "open_overlay", true); // non interactive
        document.addEventListener(visibilityChange, handleVisibilityChange, false);
    }

    function triggerClose() {
        analytics.event("feeds_tab_overlay", "close_switch_tab_overlay", "exit_overlay");
        document.removeEventListener(visibilityChange, handleVisibilityChange);
        store.dispatch(closeFeedSwitchTabOverlay());
        storage.set("newTabOverlay", "disabled");
        storage.remove("newTabOverlayProductId");
    }

    if (!overlayOpen) {
        return null;
    }

    const overlayContent = (
        <div className={styles.captureForm}>
            <div>
                <img src={product.image_url} alt={product.image_alt_text} />
                <p>
                    {"The "}
                    <strong>{product.short_description}</strong>
                    {" by "}
                    <strong>{product.designer_name}</strong>
                    {" is open in your browser's previous tab."}
                </p>
                <Button onClick={triggerClose} styleType="tertiary">
                    {"Continue browsing Lyst"}
                </Button>
            </div>
        </div>
    );

    return (
        <div id="feed-switch-tab-overlay" ref={appElement}>
            <Modal
                appElement={document.body}
                isOpen={overlayOpen}
                onAfterOpen={triggerAfterOpen}
                onRequestClose={triggerClose}
                className={styles.modal}
                overlayClassName={styles.overlay}
            >
                {product.designer_name && (
                    <div className={styles.modalContent}>{overlayContent}</div>
                )}
            </Modal>
        </div>
    );
}

export default withReduxProvider(
    connect(mapStateToProps, mapDispatchToProps)(FeedSwitchTabOverlay)
);

FeedSwitchTabOverlay.propTypes = {
    overlayOpen: PropTypes.bool,
};
